import React from 'react';
import { motion } from 'framer-motion';
import { LockIcon, CheckIcon, AlertCircleIcon } from 'lucide-react';
export function FinalCTA() {
  return <section className="w-full py-20 px-4 bg-warm-cream" data-id="element-31">
      <div className="max-w-4xl mx-auto" data-id="element-32">
        <div className="text-center mb-12" data-id="element-33">
          <div className="w-4 h-4 bg-secondary-coral rounded-full mx-auto mb-6 animate-pulse" data-id="element-34"></div>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-text-heading" data-id="element-35">
            ELEGÍ TU OPCIÓN:
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16" data-id="element-36">
          {/* Option A - Recommended */}
          <motion.div whileHover={{
          y: -5
        }} className="bg-white rounded-2xl p-8 shadow-xl border-2 border-primary-green relative flex flex-col h-full" data-id="element-37">
            <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 bg-primary-green text-white px-4 py-1 rounded-full text-sm font-bold whitespace-nowrap" data-id="element-38">
              OPCIÓN A — PACK COMPLETO RECOMENDADO
            </div>

            <div className="text-center mb-6 mt-4" data-id="element-39">
              <h3 className="text-xl font-bold text-text-heading mb-2" data-id="element-40">
                MÉTODO COMPLETO
              </h3>
              <p className="text-text-body" data-id="element-41">
                Método Mesa en Paz + Kit de Implementación Rápida
              </p>
            </div>

            <div className="text-center mb-8" data-id="element-42">
              <p className="text-gray-500 line-through text-lg mb-1" data-id="element-43">$44.990</p>
              <p className="text-4xl font-bold text-[#3D7A5E]" data-id="element-44">
                $29.990{' '}
                <span className="text-xl text-gray-500 font-normal" data-id="element-45">ARS</span>
              </p>
            </div>

            <a href="https://fegion.shop/cart/46217733341323:1" className="block w-full bg-primary-green hover:bg-primary-green-hover text-white text-center py-4 rounded-xl font-bold transition-colors shadow-md mb-6" data-id="element-46">
              → SÍ, QUIERO EL MÉTODO COMPLETO ←
            </a>

            <div className="mt-auto space-y-3" data-id="element-47">
              <div className="flex items-center justify-center text-sm text-text-body" data-id="element-48">
                <CheckIcon className="w-4 h-4 text-primary-green mr-2" data-id="element-49" /> Todo
                incluido
              </div>
              <div className="flex items-center justify-center text-sm text-text-body" data-id="element-50">
                <CheckIcon className="w-4 h-4 text-primary-green mr-2" data-id="element-51" /> Acceso
                inmediato
              </div>
              <div className="flex items-center justify-center text-sm text-text-body" data-id="element-52">
                <CheckIcon className="w-4 h-4 text-primary-green mr-2" data-id="element-53" />{' '}
                Descarga en segundos
              </div>
            </div>
          </motion.div>

          {/* Option B */}
          <motion.div whileHover={{
          y: -5
        }} className="bg-white rounded-2xl p-8 shadow-md border border-gray-200 flex flex-col h-full justify-center" data-id="element-54">
            <div className="text-center mb-6" data-id="element-55">
              <h3 className="text-lg font-bold text-gray-500 mb-2" data-id="element-56">OPCIÓN B</h3>
              <p className="text-text-heading font-medium" data-id="element-57">
                Solo el Método Base
              </p>
            </div>

            <div className="text-center mb-8" data-id="element-58">
              <p className="text-3xl font-bold text-text-heading" data-id="element-59">
                $19.990{' '}
                <span className="text-lg text-gray-500 font-normal" data-id="element-60">ARS</span>
              </p>
            </div>

            <a href="https://fegion.shop/cart/46217733111947:1" className="block w-full text-center py-3 text-gray-500 hover:text-text-heading underline transition-colors" data-id="element-61">
              No gracias, prefiero solo el Método Mesa en Paz sin el Kit de
              Implementación
            </a>
          </motion.div>
        </div>

        {/* Guarantee */}
        <div className="bg-guarantee-bg rounded-2xl p-8 md:p-10 border border-primary-green/20 flex flex-col md:flex-row items-center text-center md:text-left mb-12" data-id="element-62">
          <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center shadow-sm mb-6 md:mb-0 md:mr-8 flex-shrink-0" data-id="element-63">
            <LockIcon className="w-8 h-8 text-primary-green" data-id="element-64" />
          </div>

          <div data-id="element-65">
            <h3 className="text-xl font-bold text-text-heading mb-2" data-id="element-66">
              GARANTÍA EN AMBAS OPCIONES
            </h3>
            <p className="text-text-body mb-2" data-id="element-67">
              Si por error técnico de nuestra parte no podés acceder al
              material, lo resolvemos en 24 horas o te devolvemos el dinero sin
              preguntas.
            </p>
            <p className="font-bold text-[#3D7A5E]" data-id="element-68">
              Sea cual sea la opción que elijas — estás completamente
              protegida/o.
            </p>
          </div>
        </div>

        {/* Legal Disclaimer & Footer */}
        <div className="border-t border-gray-200 pt-12 text-center" data-id="element-69">
          <div className="bg-light-coral/30 rounded-xl p-6 mb-8 inline-block max-w-3xl text-left" data-id="element-70">
            <div className="flex items-start" data-id="element-71">
              <AlertCircleIcon className="w-6 h-6 text-secondary-coral mr-3 flex-shrink-0 mt-0.5" data-id="element-72" />
              <div data-id="element-73">
                <h4 className="font-bold text-text-heading mb-2" data-id="element-74">
                  AVISO LEGAL
                </h4>
                <p className="text-sm text-text-body leading-relaxed" data-id="element-75">
                  Este material tiene fines exclusivamente educativos e
                  informativos. No constituye diagnóstico, tratamiento ni
                  consejo médico, nutricional o terapéutico de ningún tipo. No
                  reemplaza la consulta con profesionales de la salud
                  especializados. Ante cualquier preocupación sobre la salud de
                  tu hijo, consultá siempre con un profesional matriculado.
                </p>
              </div>
            </div>
          </div>

          <p className="font-bold text-text-heading" data-id="element-76">
            by Grupo Fegion — Para la familia argentina que quiere una mesa en
            paz.
          </p>
        </div>
      </div>
    </section>;
}